import angular from 'angular';
import Rx from 'rx';

export default function LoginController($scope, $localstorage, $wamp, $http, settings, $mdDialog, $mdToast, UserService, $state, $timeout) {

  $scope.user = {};

  $scope.cancel = function () {
    $state.go('home');
    $mdDialog.cancel();
    $timeout(function () {
      location.reload();
    }, 300);
  };

  const defaultDialogOptions = {
    parent: angular.element(document.body),
    preserveScope: true,
    clickOutsideToClose: false,
    escapeToClose: false,
    scope: $scope
  };

  const loginDialogOptions = angular.extend({template: require('../views/login.html')}, defaultDialogOptions);
  const selectCodeTypeDialogOptions = angular.extend({template: require('../views/two-factor-pref.html')}, defaultDialogOptions);
  const sendCodeDialogOptions = angular.extend({template: require('../views/two-factor-code.html')}, defaultDialogOptions);
  const unknownErrorDialogOptions = angular.extend({template: require('../views/login-error.html')}, defaultDialogOptions);
  const duplicateLoginOptions = angular.extend({template: require('../views/login-duplicates.html')}, defaultDialogOptions);

  //Listen for WAMP open
  var openSubscription = $scope.$eventToObservable('$wamp.open')
      .flatMap(function (data) {
        return data[1].details.authroles[0] === 'exceeded.login'
            ? Rx.Observable.throw('Duplicate Login Attempts')
            : Rx.Observable.return(data);
      })
      .subscribe(
          function (data) {
            UserService.setRoles(data[1].details.authroles || [data[1].details.authrole]);
            UserService.load();
          },
          function (error) {
            console.error(error);
            $scope.message = error.message;

            if (error.message === 'Duplicate Login Attempts') {
              $mdDialog.show(duplicateLoginOptions);
            }
          });

  // Normal/intentional disconnects we should stay silent about.
  var NORMAL_CLOSE_REASONS = [
    'wamp.close.normal',
    'wamp.close.goodbye_and_out',
    'wamp.close.closed_normally'
  ];

  // The login could not be CHECKED, as opposed to being wrong: the router's
  // resolver is down (router.error.resolver_unavailable) or the resolver's
  // database is (eci.login.unavailable). The token is still good. Keep it,
  // tell the user, and let thruway.js reconnect on its backoff; the next
  // challenge is answered from local storage as usual.
  var OUTAGE_REASONS = [
    'router.error.resolver_unavailable',
    'eci.login.unavailable'
  ];
  var isOutage = function (reason) {
    return !!reason && OUTAGE_REASONS.some(function (r) {
      return reason === r || reason.endsWith(r);
    });
  };

  // One persistent banner across the top for "we are not connected right
  // now": shown while thruway.js retries, replaced if the reason changes,
  // hidden on open. An md-toast with our own template and class
  // (.connection-banner in main.css) so it is full width and hard to miss.
  // Only the member area depends on the socket. A stored token opens it on
  // every page, so a failure on the public site would otherwise show a banner
  // where nothing needs the connection. Remember the problem and show it on
  // entering the member area if it is still unresolved.
  var connectionIssue = null;     // current problem text, or null when connected
  var connectionToastText = null; // what is on screen, or null
  var inMemberArea = function () {
    return $state.includes('member');
  };
  var renderConnectionToast = function () {
    var wanted = inMemberArea() ? connectionIssue : null;
    if (wanted === connectionToastText) {
      return;
    }
    if (wanted === null) {
      $mdToast.hide();
      connectionToastText = null;
      return;
    }
    connectionToastText = wanted;
    $mdToast.show(
        $mdToast.simple()
            .textContent(wanted)
            .toastClass('connection-banner') // full-width orange strip, main.css
            .position('top left')
            .hideDelay(0)
    );
  };
  var showConnectionToast = function (text) {
    connectionIssue = text;
    renderConnectionToast();
  };
  var hideConnectionToast = function () {
    connectionIssue = null;
    renderConnectionToast();
  };
  var stateChangeUnbind = $scope.$on('$stateChangeSuccess', renderConnectionToast);
  var showOutage = function () {
    showConnectionToast('Login is temporarily unavailable. Retrying...');
  };
  var hideOutage = hideConnectionToast;

  // The socket itself failed (nginx or the router down, network dropped).
  // thruway.js keeps reconnecting on a backoff; the session and token are
  // untouched, so the app just picks up where it was once it reconnects.
  var disconnectedSubscription = $scope.$eventToObservable('$wamp.disconnected')
      .subscribe(function (data) {
        console.log("connection lost", data[1] && data[1].message);
        showConnectionToast('Connection lost. Reconnecting...');
      });

  var closes$ = $scope.$eventToObservable('$wamp.close')
      .filter(function (data) {
        return data[1].details.reason;
      });

  var outageSubscription = closes$
      .filter(function (data) {
        return isOutage(data[1].details.reason);
      })
      .subscribe(function (data) {
        console.log("login outage", data[1].details.reason);
        showOutage();
      });
  var outageClearSubscription = $scope.$eventToObservable('$wamp.open').subscribe(hideOutage);

  //If the WAMP connection closes because of an authentication failure, we need
  // to clear out the tokens and manually retry connecting
  var closeSubscription = closes$
      .filter(function (data) {
        var details = data[1].details;
        console.log("reason", details.reason);
        if (isOutage(details.reason)) {
          return false; // handled above; the token stays
        }
        // The WAMP server's 2FA auth-failure reason isn't always one of the two
        // we used to hard-code, so also surface any close that carries a
        // server-sent message and isn't a normal disconnect. Otherwise a 2FA
        // rejection with a different reason vanishes and the user sees nothing.
        return details.reason === 'thruway.error.authentication_failure'
            || details.reason === 'eci.login.failure'
            || (!!details.message && NORMAL_CLOSE_REASONS.indexOf(details.reason) === -1);
      })
      .throttle(1000)
      .subscribe(function (data) {
        $scope.message = data[1].details.message;
        if ($localstorage.get('masqtoken')) {
          $localstorage.del('masqauthid');
          $localstorage.del('masqtoken');
        }
        else {
          $localstorage.del('authid');
          $localstorage.del('ecitoken');
        }
        if ($scope.message === 'Expired token') {
          location.reload();
          return;
        }

        $mdDialog.show(unknownErrorDialogOptions);

        // location.reload();
      });

  //Listen for a WAMP Challenge
  const challenge$ = $scope.$eventToObservable('$wamp.onchallenge')
      .filter(function (data) {
        return data[1].method === 'jwtauth';
      }).map(function (data) {
        return data[1].promise;
      });

  //Check for local token
  const localToken$ = Rx.Observable
      .of(0)
      .map(function () {
        return $localstorage.get('masqtoken') || $localstorage.get('ecitoken');
      })
      .filter(function (token) {
        return token;
      });

  //Check for local two factor data
  const localTwoFactorData$ = Rx.Observable.just($localstorage.get('twofactordata'))
      .filter(function (data) {
        return data;
      })
      .map(function (data) {
        return JSON.parse(data);
      });

  const loginDialog = function () {
    $scope.user.username = null;
    $scope.user.password = null;
    $scope.message = null;
    $scope.saving = false;

    return Rx.Observable.timer(200)
        .do(function () {
          $mdDialog.show(loginDialogOptions);
        })
        .flatMap($scope.$createObservableFunction('sendLoginInfo').take(1))
        .do(function () {
          $scope.saving = true;
        })
        .flatMap(function (user) {
          var deviceToken = $localstorage.get('devicetoken');
          return $http.get(settings.login_url + '/login_b/' + btoa(user.username) + '/' + btoa(user.password) + '/' + deviceToken);
        })
        .pluck('data')
        .catch(function (error) {
          $scope.$apply(function () {
            $scope.saving = false;
            $scope.message = error.status === 401 ? "Login Failed, try again" : "There was an error connecting to the server. Please try again.";
          });
          throw new Error('Login Failed');
        })
        .retry(3);
  };

  const selectCodeTypeDialog = function (data) {
    $scope.methods = data.two_factor_options;
    $scope.saving = false;

    return Rx.Observable.return($mdDialog.show(selectCodeTypeDialogOptions))
        .flatMap($scope.$createObservableFunction('sendTwoFactorMethod').take(1))
        .do(function () {
          $scope.saving = true;
        })
        .flatMap(function (code) {
          // return $http.get(settings.login_url + '/sendCode/' + code + '/' +
          // data.two_factor_token);
          return $http.get(settings.login_url + '/sendCode/' + code + '/' + data.two_factor_token + '/www');
        })
        .map(data.two_factor_token)
        .catch(function (error) {
          $localstorage.del('twofactordata');
          throw Error('Two Factor Auth Failure');
        });
  };

  const submitCodeDialog = function (token) {
    $scope.message = null;
    $scope.saving = false;

    return Rx.Observable.return($mdDialog.show(sendCodeDialogOptions))
        .flatMap($scope.$createObservableFunction('sendTwoFactorCode').take(1))
        .do(function () {
          $scope.saving = true;
        })
        .flatMap(function (code) {
          return $http.get(settings.login_url + '/submitCode/' + code + '/' + token);
        })
        .catch(function (error) {
          $scope.$apply(function () {
            $scope.saving = false;
            $scope.message = error.status === 401 ? "Invalid Code, try again" : "There was an error connecting to the server. Please try again.";
          });
          throw new Error('Invalid Code');
        })
        .retry(3)
  };

  const loginDialog$ = Rx.Observable.timer(200).flatMap(loginDialog).shareReplay(1);

  const selectCodeTypeDialog$ = localTwoFactorData$.concat(loginDialog$).take(1)
      .filter(function (data) {
        return !data.login_token;
      })
      .do(function (data) {
        $localstorage.set('twofactordata', JSON.stringify(data));
      })
      .flatMap(selectCodeTypeDialog);

  const submitCodeDialog$ = selectCodeTypeDialog$.flatMap(submitCodeDialog).do(function (x) {
    if (x.data.device_token) {
      $localstorage.set('devicetoken', x.data.device_token);
    }
  });

  const twoFactorLoginToken$ = submitCodeDialog$.pluck('data', 'login_token');

  const skip2FLoginToken$ = loginDialog$.pluck('login_token').filter(function (lt) {
    return lt;
  });

  const challengeSubscription = challenge$
      .flatMapLatest(function (deferred) {
        return Rx.Observable
            .concat(localToken$, skip2FLoginToken$, twoFactorLoginToken$)
            .take(1)
            .map(function (token) {
              return [deferred, token];
            })
      })
      .subscribe(
          function (tokenData) {
            $mdDialog.cancel();
            var deferred = tokenData[0];
            var token = tokenData[1];
            deferred.resolve(token);
            if ($localstorage.get('masqauthid')) {
              $localstorage.set('masqtoken', token);
            }
            else {
              $localstorage.set('ecitoken', token);
            }

            $localstorage.del('twofactordata');
          },
          function (error) {
            console.error(error);
            $scope.message = error.message;
            $mdDialog.show(unknownErrorDialogOptions);
          });

  $scope.logout = function () {
    $localstorage.del('ecitoken');
    $localstorage.del('authid');
    $localstorage.del('masqtoken');
    $localstorage.del('masqauthid');

    $state.go('home');
    $timeout(function () {
      location.reload();
    });
  };

  $scope.$on('$destroy', function () {
    let disposables = new Rx.CompositeDisposable(openSubscription, closeSubscription, challengeSubscription, outageSubscription, outageClearSubscription, disconnectedSubscription);
    stateChangeUnbind();
    hideOutage();
    disposables.dispose();
  });
}
